import { TbaParameter } from './tba-parameter';
import { Tba } from './tba';

export class BaseTbaParameter {
  parameterValue: number;
  tba: Tba;
  tbaParameter: TbaParameter;
}
